/** 
 * player mixin for smarttv app 
 * advance function included DRM and DVR mode
 * timer will update timeline per specified time (if media is playing)
 */

import SpotvPlayer from '../now/spotvPlayer'
import { getDeviceType } from '../utils/common'

const PlayerMixin = {

  data:() => ({
    spotvPlayer: null,
    isDvr: false,
    isDrm: false
  }),

  methods: {
    async manifestLoader(vodId) {
			let dispatchType = this.isLive ? "FETCH_LIVE_DATA" : "FETCH_VOD_DATA"
			await this.$store.dispatch(dispatchType, vodId).then(async response => {
        // Live 방송 상태 체크
        if(this.isLive && process.env.VUE_APP_OS_TYPE == "lg") {
          this.$progress.$emit("liveCheck", response.data.status)
          // 0: 방송전, 2: 방송종료
          if (response.data.status == 2 || response.data.status == 0) { 
            return;
          }
        }

        // 타겟 컴포넌트의 start() method 호출
        let parsedSource = await this.responseParser(response.data)

        console.log("parsed source", parsedSource)
        this.start(parsedSource)
        // if (this.isLive) this.loadStream(this.player, parsedSource).catch((err) => { console.error(err) })
      })


      /** DRM or DVR 사용 시 아래 주석 사용 */
      // // this.isDvr = response.data.playbackTokenDvr !== ""
      
      // this.isDvr = false // DVR 이슈로 인한 false 처리
      // this.isDrm = response.data.isDrm

      // this.$store.dispatch("FETCH_PLAYBACK_DATA", {
      //   videoId: response.data.videoId,
      //   adConfig: this.isDvr ? response.data.playbackTokenDvr : response.data.playbackToken,
      // }).then((manifest) => {
      //   let manifestUrl = manifest.data.sources
      //   if (this.isLive) {
      //     if (this.isDrm) {
      //       this.loadWithDrm(this.player, manifestUrl).catch((err) => {
      //         this.historyBack()
      //         // this.loadStream(this.player, manifestUrl[0].src).catch((err) => {
      //         //   console.error(err)
      //         // })
      //       })
      //     } else {
      //       this.loadStream(this.player, manifestUrl[0].src).catch((err) => {
      //         console.error(err)
      //         this.historyBack()
      //       })
      //     }
      //   } else {
      //     this.start(this.selectVideoToPlay(manifestUrl))
      //   }
      // })
		},

		/****************************************************************************************
		 * @description 202110 GS 네오텍 CDN 연동
		 * @author qpoiop
		 ****************************************************************************************
		* @param {Number (400|500)}  ottType             - 400: 기존 Brightcove 사용, 500: 네오텍 CDN 소스 사용
		* @param {String, Number}    videoId             - VOD인 경우 해당 video의 Id, Live인 경우 채널 ref_id
    * @param {String, Number}    drmVideoId          - DRM 소스인 경우 videoId 대신 사용 (Brightcove)
		* @param {String}            hlsUrl              - ottType이 400일 때 사용
		* @param {String}            hlsUrl2             - ottType이 400이고 isDrmStv이 true일 때 사용
		* @param {String}            playbackToken       - 일반 스트림 영상에 사용
		* @param {String}            playbackTokenDvr    - DVR 적용된 스트림 영상에 사용
		* @param {Boolean}           isDrmLgtv           - DRM 여부 (LG STV 전용)
    * @param {Boolean}           isDrmSstv           - DRM 여부 (SAMSUNG STV 전용)
		* @param {String}            drmPlaybackToken    - DRM 적용된 소스인 경우 사용 (BC adConfig값)
		* @param {String}            drmPlaybackTokenDvr - DRM과 DVR 모두 적용일 때 사용 (BC adConfig값)
		****************************************************************************************
		* @returns {String:manifestUrl, Boolean:isDvr, Boolean:isDrm} 해당하는 컴포넌트에서 재생시킬 미디어 정보
		****************************************************************************************/
		async responseParser({ 
			ottType = 400, 
      ottType2 = 400, 
			videoId = null,
      drmVideoId = null,
			hlsUrl = null, 
			hlsUrl2 = null, 
			playbackToken = '', 
			playbackTokenDvr = '', 
			isDrmLgtv = false, 
      isDrmSstv = false, 
			drmPlaybackToken = '', 
			drmPlaybackTokenDvr = ''
		} = {}) {
			let isDvr = (playbackTokenDvr !== '' || drmPlaybackTokenDvr !== ''),
          isDrm = getDeviceType() == "samsung" ? isDrmSstv : isDrmLgtv, // local인 경우(pc) LG 테스트 사용
          type = isDrm ? ottType2 : ottType

			if (this.isLive && type === 500) return isDrm ? hlsUrl2 : hlsUrl
			else { 
          // TODO: 실제 DRM 기능 적용 필요
          let adConfig = isDrm ? (isDvr ? drmPlaybackTokenDvr : drmPlaybackToken) : (isDvr ? playbackTokenDvr : playbackToken),
              videoRef = isDrm ? drmVideoId : videoId

          try {
            // Brightcove API 통한 manifest 동기적 호출
            const manifest = await this.$store.dispatch("FETCH_PLAYBACK_DATA", { videoId: videoRef, adConfig })
              // 라이브가 아닌 경우 source의 가장 높은 bitrate(height) 선택하여 반환
            return this.isLive ? manifest.data.sources[0].src : this.selectVideoToPlay(manifest.data.sources)
          } catch(err) {
            this.historyBack()
          }
        }
		},

    // 존재하는 소스 중에서 최상의 bitrate 선택
    selectVideoToPlay(vodList) {
      let temp = { height: 0, avg_bitrate: 0, src: "" }

      for (let i in vodList) {
        try {
          if (vodList[i].codec == "H264") {
            if (vodList[i].height > temp.height) {
              temp = vodList[i]
            } else if (
              vodList[i].height == temp.height &&
              vodList[i].avg_bitrate > temp.avg_bitrate
            ) {
              temp = vodList[i]
            }
          }
        } catch (e) {
          console.log(e)
        }
      }

      return temp.src
    },

    /**
     * @description call player modules (shaka) from window object
     * @param {Element} video - The <video> element
     * @param {String} manifestUrl - The media source url
     * @param {String} licenseUrl - The DRM License server url (widevine)
     * @param {String} token - The DRM token value (widevine)
     * @returns {Promise} promise function
     */
    loadStream(video = this.video, manifestUrl, licenseUrl=null, token=null) {
      return new Promise(function(resolve, reject) {
        try {
          if (this.spotvPlayer) this.spotvPlayer.destroy()

          this.spotvPlayer = new SpotvPlayer()
          this.spotvPlayer.configure({
            os: 'web',
            mediaElement: video,
            manifestUrl: manifestUrl,
            widevine: {
              licenseUrl: licenseUrl,
              token: token
            }
          })

          this.spotvPlayer.load((isReady) => {
            this.isPlaying = isReady
            if (isReady) {
              this.addPlayerEvents(video)                           // add video event listeners
              this.spotvPlayer.tickInterval(this.updateTrack, 0.25) // Update media track per 0.25 miliseconds
              resolve()
            } else {
              reject("fail to load Stream")
            }
          })
        } catch (err) {
          reject(err)
        }
      }.bind(this))
    },

    /**
     * @description Parsing metadata from brightcove sources
     * @param {HTMLElement} video - The <video> Element
     * @param {Object} metadata - The brightcove api's response
     * @returns {Promise} promise function
     */
    loadWithDrm(video = this.player, sources, isDvr=false) {
      return new Promise((resolve, reject) => {
         try {

          let sources_ = sources.filter(source => hasOwnProperty.call(source['key_systems'], 'com.widevine.alpha'))
          
          let dashStream = sources_.find(source => source['type'] == 'application/dash+xml'), 
              hlsStream = sources_.find(source => source['type'] == 'application/x-mpegURL')
          
          if (!dashStream && !hlsStream) throw new Error("dash+widevine source is not found")
          let stream = dashStream ? dashStream : hlsStream
          let manifestUrl = stream.src
          
          // if (sources_['key_systems'].hasOwnProperty('com.widevine.alpha')) {
            let { license_url } = stream['key_systems']['com.widevine.alpha'],
                drm_server_url = license_url.split("?token=")

            return this.loadStream(video, manifestUrl, drm_server_url[0], drm_server_url[1]).catch((err) => {
              console.error("failed load Stream", err)
              reject(err)
            }).then(() => resolve(manifestUrl))

          // } else if (source_['key_systems'].hasOwnProperty('com.microsoft.playready')) {
            //TODO use playready drm engine

            // throw new Error("playready key system was found")
          // } else throw new Error("browser key system was not found")
        } catch (err) {
          // TODO: use basic html player instead
          console.error("Failed parsing DRM metadata", err)
          reject(err)
        }
      })
    },

    // custom player Events
    addPlayerEvents(video) {
      video.onloadstart = function() { 
        console.log("PLAYER START TO LOAD")
        this.$progress.$emit("on:progress")
      }.bind(this)
      video.oncanplay = function() {
        console.log("PLAYER STREAMING READY TO START")
        this.$progress.$emit("off:progress")
        this.play() //play and sendViewlogs
      }.bind(this)
      video.onloadedmetadata = function() {
        console.log("PLAYER STREAMING READY TO START")
        this.$progress.$emit("off:progress")
        this.play() //play and sendViewlogs
      }.bind(this)
      video.onended = function() {
        console.log("PLAYER STREAMING IS ENDED")
        this.$progress.$emit("off:progress")
        this.unload()
        this.$router.go(-1)
      }.bind(this)
      // player.onseeking  = function() {
      //   console.log("PLAYER START TO SEEKING")
      // }.bind(this)
    },


    /**
     * update timeline (progressbar and indicator) from media track
     * need to calc currentTime, duration and buffer length
     */
    updateTrack() {
      
      // Update timeline when video overlay is showing
      if (!(this.spotvPlayer && this.show && !this.dragMode)) return
      
      const currentTime = this.spotvPlayer.player_.currentTime()
      const {end: seekEnd, start: seekStart} = this.spotvPlayer.player_.seekRange()

      this.playPostion = currentTime
      const currentPosition = this.isDvr ? parseFloat((currentTime-seekStart)/(seekEnd-seekStart)*1680) : 1680
      // console.log("clampedCurrentTime", clampedCurrentTime, "seekEnd", seekEnd, "seekStart", seekStart)

      if (currentPosition < 1675) this.indicatorX = this.progressBarX = currentPosition 
      else if (currentPosition < 5) this.indicatorX = this.progressBarX = 0
      else this.indicatorX = this.progressBarX = 1680
    },

    /**
     * update timeline when user dragging with indicator
     */
    updateIndicator() {
      if (!(this.isLive && this.isDvr)) return 
      if (this.spotvPlayer.player_.isSeeking()) return

      this.progressBarX = this.indicatorX
      
      const {end: seekEnd, start: seekStart} = this.spotvPlayer.player_.seekRange()
      let currentIndicator = parseFloat((this.indicatorX / 1680)*(seekEnd - seekStart))
      
      // Check if indicator is out of range
      if ((currentIndicator <= seekEnd)) this.moveTo(seekStart + currentIndicator) 
    },

    /**
     * @description Set time from timeline to video
     * @param {Number} timeInSeconds 
     */
    moveTo(timeInSeconds) {
      if (this.spotvPlayer.player_.isSeeking()) return

      this.spotvPlayer.player_.pause()
      this.spotvPlayer.tickDebounce(() => {
        const {end: seekEnd, start: seekStart} = this.spotvPlayer.player_.seekRange()
  
        console.log("start", seekStart, "end", seekEnd, "next", timeInSeconds)
        
        if (timeInSeconds <= seekStart || timeInSeconds < 0) this.spotvPlayer.mediaElement_.currentTime = seekStart
        else if (timeInSeconds >= seekEnd) this.spotvPlayer.mediaElement_.currentTime = seekEnd
        else this.spotvPlayer.mediaElement_.currentTime = timeInSeconds
  
        this.spotvPlayer.tickInterval(this.updateTrack, 0.25)
        this.spotvPlayer.player_.play()
      }, 0.5)
    },


    /** call this function when before player view destroyed */
    unload() {
      if (this.spotvPlayer) {
        this.spotvPlayer.destroy()
        this.spotvPlayer = null
      }
    }
  }
}

export default PlayerMixin